<template>
  <div v-if="article">
    <p class="font-montserrat" :class="article.category.name.toLowerCase()">
      {{ article.category.name }} |
      <span class="fw-light">
        {{
          new Date(article.created_at).toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })
        }}
      </span>
    </p>
    <heading-two
      class="mb-3 font-poppins custom-article-title-height"
      :text="article.title"
    />
    <paragraph-size-six
      :paragraph-text="article.excerpt"
      line-height="lh-xl"
      class="cut-text mb-5"
    />
    <router-link
      :to="{ name: 'BlogShow', params: { blogId: article.id } }"
      :class="article.category.name.toLowerCase()"
      class="btn btn-light shadow rounded-pill fs-5 fw-light font-montserrat mt-auto col-9 col-sm-6 col-lg-7 col-xl-6"
    >
      Read More
    </router-link>
  </div>
</template>
<script>
export default {
  name: "BlogArticle",
  components: { ParagraphSizeSix, HeadingTwo },
};
</script>
<script setup>
import { defineProps } from "vue";
import HeadingTwo from "@/components/base-components/HeadingTwo";
import ParagraphSizeSix from "@/components/base-components/ParagraphSizeSix";

defineProps({
  article: {
    type: Object,
    default: null,
  },
});
</script>

<style scoped>
.cut-text {
  display: -webkit-box;
  -webkit-line-clamp: 4; /* Number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.product {
  color: #b63cff;
}
.methodologies {
  color: #00b9ff;
}
.scenarios {
  color: #31da00;
}
@media (min-width: 770px) and (max-width: 990.09px) {
  .custom-article-title-height {
    height: 64px !important;
  }
}
@media (min-width: 991px) and (max-width: 1399.09px) {
  .custom-article-title-height {
    height: 100px !important;
  }
}
@media (min-width: 1400px) {
  .custom-article-title-height {
    height: 68px !important;
  }
}
</style>
